import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

// Animates "95K+" / "600+" style values from 0 when scrolled into view. Non-numeric values render as-is.
export const CountUp = ({ value, className = "", ...rest }) => {
  const m = /^(\d+)(.*)$/.exec(value);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: "some" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView || !m) return;
    const controls = animate(0, Number(m[1]), { duration: 1.6, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, value]);

  return <p ref={ref} className={`tabular-nums ${className}`} {...rest}>{m ? `${n}${m[2]}` : value}</p>;
};
